// extracted by mini-css-extract-plugin
module.exports = {"container":"Link_container__zwbTa","onThisRoute":"Link_onThisRoute__2kYpx","external":"Link_external__2gflL","internal":"Link_internal__2y7Ow"};